import {
  InventoryStockBalanceRecord,
  SaveInventoryStockBalanceRequest,
} from '@/renderer/types/inventory';

export interface InventoryStockBalanceFormState {
  stockLocationId: string;
  inventoryItemId: string;
  quantityOnHand: string;
  averageCost: string;
}

export const createEmptyInventoryStockBalanceForm =
  (): InventoryStockBalanceFormState => ({
    stockLocationId: '',
    inventoryItemId: '',
    quantityOnHand: '0',
    averageCost: '0',
  });

export const createInventoryStockBalanceFormFromRecord = (
  record: InventoryStockBalanceRecord,
): InventoryStockBalanceFormState => ({
  stockLocationId: record.stock_location_id,
  inventoryItemId: record.inventory_item_id,
  quantityOnHand: String(record.quantity_on_hand),
  averageCost: String(record.average_cost),
});

export const buildSaveInventoryStockBalancePayload = (
  companyId: number,
  outletId: string,
  form: InventoryStockBalanceFormState,
  id?: string,
): SaveInventoryStockBalanceRequest => ({
  id,
  companyId,
  outletId,
  stockLocationId: form.stockLocationId,
  inventoryItemId: form.inventoryItemId,
  quantityOnHand: Number(form.quantityOnHand || 0),
  averageCost: Number(form.averageCost || 0),
});
